import { Component, HostListener, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'vpostcode';
  constructor(private keycloakService: KeycloakService){}
  ngOnInit(): void {
    // this.keycloakService.isLoggedIn().then((islogin: boolean)=>{

    //   if(islogin){
    //     var token = this.keycloakService.getToken();
    //     console.log(token)
    //   }
    // })
  }
}
